<script setup lang="ts">
const Icon = useIcon();
import { TwitterIcon } from 'assets/data/icons';
</script>
<template>
  <Icon :path="TwitterIcon" :size="30" class="w-7" filled />
</template>
